export default {
  title: 'Attiva prenotazioni',
  buttons: {
    cancel: 'Annulla',
    activate: 'Attiva prenotazioni',
  },
};
